module.exports = __webpack_public_path__ + "static/intro-header-200d688c65d9a63894e3db72814419a1.jpg";